// extracted by mini-css-extract-plugin
export default {"name":"OwnerCell_name__RzNnN","unset":"OwnerCell_unset__Yz0Fz","anchor":"OwnerCell_anchor__5ChpQ"};